exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@use 'sass:map';.no-scroll[data-v-0a3bb5b1]{position:relative;z-index:100;overflow:hidden}.refer[data-v-0a3bb5b1]{color:#07a17b !important;border-color:#07a17b !important}\n", ""]);
